<template lang="html">
  <div class="card-invite card-user">
    <div class="card-invite-form">
      <input-component
        type="text-btn"
        icon="arrow-right"
        label=""
        btntype="btn-success"
        placeholder="Filtro"
        @inputactionclick="buscarComFiltro"
        @inputactionenter="buscarComFiltro"
      />
    </div>
    <table class="table table-hover">
      <thead class="thead-light">
      <tr>
        <th scope="col">ID</th>
        <th scope="col">Data criação</th>
        <th scope="col">Status</th>
        <th scope="col">Cliente</th>
        <th scope="col">Valor</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="tx in txs.list" v-bind:key="tx.id">
        <th scope="row"><router-link :to="{name: 'TransactionDetails', params: { txid: tx.uuid }}"><small>{{tx.uuid}}</small></router-link></th>
        <td>{{tx.dateCreated | moment}}<br/><span class="text-muted">{{tx.dateCreated | moment-hour}}</span></td>
        <td>{{tx.status}}</td>
        <td>{{tx.buyerEmail}}<br/><span class="text-muted">{{tx.buyerName}}</span></td>
        <td>{{tx.amount | numeral('$ 0,0.00') }}</td>
      </tr>
      </tbody>
    </table>
    <b-pagination size="md" align="center" :total-rows="total" v-model="currentPage" :per-page="max" @change="fetchData">
    </b-pagination>
  </div>
</template>

<script>
import Button from '../button/Button.vue'
import Input from '../form/Input.vue'

export default {
  props: ['refreshList', 'orderList'],
  components: {
    'input-component': Input,
    'button-component': Button
  },
  data () {
    return {
      name: null,
      txs: [],
      currentPage: 1,
      max: 10,
      total: 0
    }
  },
  mounted () {
    this.fetchData(1)
  },
  methods: {
    fetchData: function (val) {
      var page = val || this.currentPage
      this.$http.get('api/transactions', {params: {offset: this.max * (page - 1), max: this.max, name: this.name, order: this.orderList}})
        .then(function (res) {
          console.log(res)
          this.txs = res.data
          this.total = res.data.total
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    buscarComFiltro: function (filtro, item) {
      console.log(filtro)
      this.name = filtro
      this.fetchData()
    },
    convertTime: function (val) {
      var seconds = Math.floor(val % 60).toString()
      var minutes = Math.floor(val / 60).toString()
      if (seconds.length === 1) {
        seconds = '0' + seconds
      }
      return minutes + 'm' + seconds + 's'
    },
    extractHostname: function (url) {
      var hostname

      if (url) {
        if (url.indexOf('://') > -1) {
          hostname = url.split('/')[2]
        } else {
          hostname = url.split('/')[0]
        }

        hostname = hostname.split(':')[0]
        hostname = hostname.split('?')[0]
      }

      return hostname
    }
  },
  watch: {
    'refreshList' () {
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variaveis.scss";
@import "../../../assets/scss/mixins.scss";
@import "../../../assets/scss/card.scss";
.card-user {
  .avatar {
    width: 40px;
  }
  .card-invite-body {
    top: 102px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/transactions/Transactions.vue